import { MinusSquare, PlusSquare } from './assets';
import { Button } from './Button';
import { useState } from 'react';

interface CommentBoxProps {
  text?: string;
  placeholder?: string;
}

export function CommentBox({ text, placeholder }: CommentBoxProps) {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div
      className={`flex-1 w-full py-1 pl-3 relative overflow-hidden border border-tertiary-300 rounded-md transition-height duration-500 ease-in-out ${
        expanded ? 'h-24 overflow-y-scroll pr-8' : 'h-8 pr-6'
      }`}
    >
      <p className={`text-left ${!text ? 'placeholder-text' : ''} text-sm`}>
        {text ? text : placeholder || 'Add comment (optional)'}
      </p>
      <Button
        type="icon"
        className="absolute right-2 top-1 w-6 h-6"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? <MinusSquare /> : <PlusSquare />}
      </Button>
    </div>
  );
}
